import * as React from 'react';

const MEDIA_QUERY = {
  MOBILE: 768,
  TABLET: 1024,
  DESKTOP_SMALL: 1280,
  DESKTOP_LARGE: 1423,
} as const;

export function useMediaQuery(query: keyof typeof MEDIA_QUERY) {
  const [matches, setMatches] = React.useState<undefined | boolean>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MEDIA_QUERY[query]}px)`);
    const onChange = () => {
      setMatches(window.innerWidth < MEDIA_QUERY[query]);
    };
    mql.addEventListener('change', onChange);
    setMatches(window.innerWidth < MEDIA_QUERY[query]);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return !!matches;
}
